import Dict from '@/utils/dict-utils'

// 采购类型字典（具有代理的采购类型字典）
export const purchaseTypeDict = new Dict({
  BIDDING: {
    value: 1,
    label: '招标',
    alias: 'bidding',
    agencyPublishPage: 'AgencyBiddingForm', // 发布招标页面(代理机构)
    agencyListPage: 'AgencyBiddingList', // 招标列表页面(代理机构)
    purchaserEntrustListPage: 'EntrustPurchaseList' // 委托项目招标列表页面(采购人)
  },
  INQUIRY: {
    value: 2,
    label: '询比',
    alias: 'inquiry',
    agencyPublishPage: 'AgencyInquiryForm', // 发布询比页面(代理机构)
    agencyListPage: 'AgencyEntrustInquiryList', // 招标列表页面(代理机构)
    purchaserEntrustListPage: 'EntrustPurchaseList' // 委托项目招标列表页面(采购人)
  },
  COMPETE: {
    value: 3,
    label: '竞价',
    alias: 'compete',
    agencyPublishPage: 'AgencyCreateCompete', // 发布竞价页面(代理机构)
    agencyListPage: 'AgencyEntrustCompeteList', // 招标列表页面(代理机构)
    purchaserEntrustListPage: 'EntrustPurchaseList' // 委托项目招标列表页面(采购人)
  },
  NEGOTIATION: {
    label: '谈判采购',
    value: 8,
    alias: 'negotiation',
    agencyPublishPage: 'AgencyNegotiationForm', // 发布询比页面(代理机构)
    agencyListPage: 'AgencyEntrustNegotiationList', // 招标列表页面(代理机构)
    purchaserEntrustListPage: 'EntrustPurchaseList' // 委托项目招标列表页面(采购人)
  },
  NEGOTIATION_V2: {
    label: '谈判采购',
    value: 9,
    alias: 'negotiation_v2'
  }
})

// 招标采购公告类型
export const announcementTypeDict = new Dict({
  PURCHASE: {
    value: 3,
    label: '采购公告',
    alias: 'purchase',
    tagLabel: '采购',
    type: 'success',
    limitMessage: {
      bid: '采购公告发布中，不能操作项目',
      inquiry: '采购公告发布中，不能操作项目',
      compete: '采购公告发布中，不能操作项目',
      negotiationV2: '采购公告发布中，不能操作项目'
    }
  },
  CANDIDATE: {
    value: 1,
    label: '候选公示',
    alias: 'candidate',
    tagLabel: '候选',
    type: 'primary',
    limitMessage: {
      bid: '中标候选公告发布中，不能操作项目',
      inquiry: '候选公告发布中，不能操作项目',
      negotiationV2: '候选公告发布中，不能操作项目'
    }
  },
  DEAL: {
    value: 2,
    label: '成交公告',
    alias: 'deal',
    tagLabel: '成交',
    type: 'primary',
    limitMessage: {
      bid: '中标结果公告发布中，不能操作项目',
      inquiry: '成交公告发布中，不能操作项目',
      compete: '成交公告发布中，不能操作项目',
      negotiationV2: '成交公告发布中，不能操作项目'
    }
  },
  CHANGE: {
    value: 4,
    label: '变更公告',
    alias: 'change',
    tagLabel: '变更',
    type: 'warning',
    limitMessage: {
      bid: '变更公告发布中，不能操作项目',
      inquiry: '变更公告发布中，不能操作项目',
      compete: '变更公告发布中，不能操作项目',
      negotiationV2: '变更公告发布中，不能操作项目'
    }
  },
  FLOW: {
    value: 5,
    label: '流标公告',
    alias: 'flow',
    tagLabel: '流标',
    type: 'primary',
    limitMessage: {
      bid: '流标公告发布中，不能操作项目',
      inquiry: '流标公告发布中，不能操作项目',
      compete: '流标公告发布中，不能操作项目',
      negotiationV2: '流标公告发布中，不能操作项目'
    }
  }
})

// 所有采购类型字典
export const purchaseAllTypeDict = new Dict({
  BIDDING: {
    ...purchaseTypeDict.BIDDING,
    type: 'primary',
    letterRouterName: 'PurchaseLetter', // 邀请详情路由
    tradeRouterName: 'SupplierPurchaseSignUp', // 交易页面路由
    detailRouterName: 'SupplierPurchaseDetail', // （供应商端）业务详情路由
    announcementType: announcementTypeDict.dictArray
  },
  INQUIRY: {
    ...purchaseTypeDict.INQUIRY,
    type: 'success',
    letterRouterName: 'InquiryLetter', // 邀请详情路由
    tradeRouterName: 'SupplierInquiryTrade', // 交易页面路由
    detailRouterName: 'SupplierInquiryDetail', // （供应商端）业务详情路由
    announcementType: announcementTypeDict.dictArray
  },
  COMPETE: {
    ...purchaseTypeDict.COMPETE,
    type: 'warning',
    letterRouterName: 'CompeteLetter', // 邀请详情路由
    tradeRouterName: 'SupplierCompeteSignUp', // 交易页面路由
    detailRouterName: 'SupplierCompeteDetail', // （供应商端）业务详情路由
    announcementType: announcementTypeDict.dictArray
  },
  BIDDING_RECORD: {
    label: '招标', // 招标的备案采购，但是在网页展示中需要展示为招标
    value: 4,
    type: 'primary',
    tradeRouterName: '',
    announcementType: []
  },
  RECRUIT: {
    label: '招募',
    value: 5,
    type: 'purple',
    tradeRouterName: 'SupplierRecruitTrade', // 交易页面路由
    announcementType: []
  },
  DEMAND: {
    label: '需求调查',
    value: 6,
    type: 'info',
    tradeRouterName: 'SupplierDemandTrade' // 交易页面路由
  },
  INTENTION: {
    label: '采购意向',
    value: 7,
    type: 'danger',
    tradeRouterName: 'SupplierIntentionTrade', // 交易页面路由
    announcementType: []
  },
  NEGOTIATION: {
    ...purchaseTypeDict.NEGOTIATION,
    type: 'warning',
    letterRouterName: 'NegotiationLetter', // 邀请详情路由
    tradeRouterName: 'SupplierNegotiationTrade', // 交易页面路由
    detailRouterName: 'SupplierNegotiationDetail', // （供应商端）业务详情路由
    announcementType: announcementTypeDict.dictArray
  },
  // 分项谈判（初始设计未南大一附院专门设计）
  NEGOTIATION_V2: {
    ...purchaseTypeDict.NEGOTIATION_V2,
    type: 'warning',
    letterRouterName: 'NegotiationV2Letter', // 邀请详情路由
    tradeRouterName: 'SupplierNegotiationV2Trade', // 交易页面路由
    detailRouterName: 'SupplierNegotiationV2Detail', // （供应商端）业务详情路由
    announcementType: announcementTypeDict.dictArray
  },
  DIRECT_PURCHASE: {
    label: '直接采购',
    value: 11,
    alias: 'biddingDirect',
    type: 'primary',
    letterRouterName: 'DirectPurchaseLetter' // 邀请详情路由
  },
  // 五菱招标
  WULING_BID: {
    label: '招标采购',
    value: 12,
    alias: 'wulingBid',
    type: 'primary',
    letterRouterName: 'WlBidLetter', // 邀请详情路由
    tradeRouterName: 'WulingBidTrade' // 交易页面
  }
})

// 项目类型字典
export const projectTypeDict = new Dict({
  GOODS: { value: 1, label: '货物类', demand: true, demandLabel: '物资类' },
  ENGINEERING: { value: 2, label: '工程类', demand: true },
  SERVICE: { value: 3, label: '服务类', demand: true },
  RAW_MATERIAL: { value: 4, label: '原材料和燃料类' },
  ASSET_DISPOSAL: { value: 5, label: '资产处置类' }
})

// 项目类型 - 资产处置方式
export const projectAssetDisposalMethodDict = new Dict({
  EXPENDITURE: {
    label: '处置支出',
    value: 1,
    desc: '委托其他企业处置，统计维度为企业处置支出金额'
  },
  INCOME: {
    label: '处置收入',
    value: 2,
    desc: '出售企业内部资产，统计维度为企业处置收入金额'
  }
})

// 项目公开范围
export const projectOpenScopeDict = new Dict({
  PLATFORM: { label: '全网公开', value: 0 },
  COMPANY: { label: '定向公开', value: 1 }
})

// 品目流标原因
export const materialFlowReasonDict = new Dict({
  1: { label: '报名供应商不足三家', value: 1 },
  2: { label: '递交文件不足三家', value: 2 },
  3: { label: '评标中有效不足三家', value: 3 },
  4: { label: '投诉质疑后重新招标', value: 4 },
  5: { label: '项目终止(重大变更)', value: 5 },
  OTHER: { label: '其他原因', value: 6 }
})

// 设置是否是否签章
export const whetherSignatureDict = new Dict({
  NEED: { label: '签章', value: 1 },
  NOT_NEED: { label: '不签章', value: 2 }
})

// 文件是否签章
export const fileWhetherSignatureDict = new Dict({
  INITIAL: { label: '未签章', value: null, type: 'info' }, // 这个作为初始状态使用，不是真正的“未签章”状态
  TO_BE_SIGNED: { label: '未签章', value: 1, type: 'info' },
  SIGNING: { label: '未签章', value: 2, type: 'info' },
  SIGNED: { label: '已签章', value: 3, type: 'success' },
  BACK: { label: '未签章', value: 4, type: 'info' },
  REJECTED: { label: '未签章', value: 5, type: 'info' }
})

// 品目单位字典
export const unitOptions = [
  { label: '平方米', value: '平方米' },
  { label: '台', value: '台' },
  { label: '件', value: '件' },
  { label: '项', value: '项' },
  { label: 'Kg', value: 'Kg' },
  { label: '批', value: '批' },
  { label: '瓶', value: '瓶' },
  { label: '盒', value: '盒' },
  { label: '包', value: '包' },
  { label: '个', value: '个' },
  { label: '支', value: '支' },
  { label: '米', value: '米' },
  { label: '千米', value: '千米' },
  { label: '具', value: '具' },
  { label: '双', value: '双' },
  { label: '张', value: '张' },
  { label: '块', value: '块' },
  { label: '罐', value: '罐' },
  { label: '盏', value: '盏' },
  { label: '孔', value: '孔' },
  { label: '付', value: '付' },
  { label: '根', value: '根' },
  { label: '把', value: '把' },
  { label: '人份', value: '人份' },
  { label: '亩', value: '亩' },
  { label: '公顷', value: '公顷' }
]

// 报名审核状态
export const auditStatusDict = new Dict({
  NOT_STARTED: {
    value: 0,
    label: '未开始',
    type: 'info',
    alias: '',
    hidden: true,
    text: 'info',
    icon: ''
  },
  PENDING: {
    value: 1,
    label: '待审核',
    supplierLabel: '审核中',
    type: 'primary',
    alias: 'pending',
    text: 'primary',
    icon: 'warning'
  },
  PASSED: {
    value: 2,
    label: '审核通过',
    supplierLabel: '审核通过',
    type: 'success',
    alias: 'passed',
    text: 'success',
    icon: 'success'
  },
  NOT_PASSED: {
    value: 3,
    label: '审核不通过',
    supplierLabel: '审核不通过',
    type: 'danger',
    alias: 'rejected',
    text: 'danger',
    icon: 'error'
  },
  TIME_OUT: {
    value: 9,
    label: '超时未审核',
    supplierLabel: '超时未审核',
    type: 'warning',
    alias: 'timeout',
    text: 'warning',
    icon: 'warning'
  }
})

// 报名审核字典
export const signUpAuditDict = new Dict({
  PASS: { value: 1, label: '审核通过', type: 'success' },
  FAIL: { value: 2, label: '审核不通过', type: 'danger' }
})

// 供应商邀请状态
export const inviteStatusDict = new Dict({
  NOT_START: { value: 0, label: '待接受', type: 'primary', hidden: true },
  PENDING: {
    value: 1,
    label: '待接受',
    type: 'primary',
    // 邀请函列表页面使用
    total: 'waitTotal',
    permission: ['detail', 'accept', 'reject']
  },
  ACCEPTED: {
    value: 2,
    label: '已接受',
    type: 'success',
    icon: 'success',
    // 邀请函列表页面使用
    total: 'acceptTotal',
    permission: ['detail']
  },
  REJECTED: {
    value: 3,
    label: '已拒绝',
    type: 'danger',
    icon: 'error',
    // 邀请函列表页面使用
    total: 'refuseTotal',
    permission: ['detail']
  },
  TIME_OUT: {
    value: 9,
    label: '超时未接受',
    type: 'info',
    icon: 'warning',
    // 邀请函列表页面使用
    total: 'timeOutTotal',
    permission: ['detail']
  }
})

// 保证金缴纳状态
export const depositStatusDict = new Dict({
  NOT_STARTED: { value: 0, label: '待缴纳', type: 'primary' },
  PENDING: { value: 1, label: '待缴纳', type: 'primary' },
  PAYMENT: { value: 2, label: '待缴纳', type: 'primary' },
  SUCCESS: { value: 3, label: '已缴纳', type: 'success' },
  FAIL: { value: 9, label: '待缴纳', type: 'primary' }
})

// 供应商中标状态
export const supplierWinnerStatusDict = new Dict({
  NOT_STARTED: {
    value: 0,
    label: '未开始',
    type: 'info',
    message: '',
    icon: ''
  },
  PENDING: {
    value: 1,
    label: '待确定',
    type: 'warning',
    message: '',
    icon: ''
  },
  AWARDED: {
    value: 2,
    label: '已授标',
    type: 'success',
    message: '恭喜你！成交了！',
    icon: 'el-icon-check',
    aIcon: 'success',
    aType: 'success'
  },
  NOT_AWARDED: {
    value: 3,
    label: '未授标',
    type: 'error',
    message: '很遗憾！你未成交！',
    icon: 'el-icon-close',
    aIcon: 'error',
    aType: 'danger'
  }
})

// 支付状态
export const paymentStatusDict = new Dict({
  NOT_STARTED: {
    value: 0,
    label: '未支付',
    resultLabel: '未支付',
    type: 'danger',
    tipLabel: '未支付'
  },
  PENDING: {
    value: 1,
    label: '待支付',
    resultLabel: '未支付',
    type: 'danger',
    tipLabel: '未支付'
  },
  PAYMENT: {
    value: 2,
    label: '支付中',
    resultLabel: '支付中',
    type: 'warning',
    tipLabel: '未支付'
  },
  SUCCESS: {
    value: 3,
    label: '支付成功',
    resultLabel: '支付成功',
    type: 'success',
    tipLabel: '已支付'
  },
  FREE: {
    value: 4,
    label: '免收支付',
    resultLabel: '免收支付',
    type: 'success',
    tipLabel: '未支付'
  }
})

// 保证金退回状态
export const depositBackStatusDict = new Dict({
  NOT_STARTED: { value: 0, label: '待申请', type: 'info', tipLabel: '未退回' },
  PENDING: {
    value: 1,
    label: '待申请',
    type: 'warning',
    tipLabel: '未退回',
    tip: '待申请'
  },
  APPLIED: {
    value: 2,
    label: '已申请，等待退回',
    type: 'primary',
    tipLabel: '退回中',
    tip: '已申请,正在退款中'
  },
  RETURNED: {
    value: 3,
    label: '退回成功',
    type: 'success',
    tipLabel: '已退回',
    tip: '退款成功'
  },
  AGREE_REFUND: {
    value: 6,
    label: '未退回（等待采购人同意退款，同意后5日内自动退款至打款账户）',
    type: 'warning',
    tipLabel: '未退回',
    tip: '待采购人同意退款'
  },
  DELAY_WIN_RETURN: {
    value: 7,
    label: '未申请（保证金将在5日内有息退回）',
    type: 'warning',
    tipLabel: '未退回'
  },
  WAITING: {
    value: 8,
    label: '支付平台服务费后可申请退回保证金', // 中标单位，请支付服务费后申请
    type: 'warning',
    tipLabel:
      '未退回（支付服务费后，等待采购人同意退款，同意后5日内自动退款至打款账户）',
    tip: '候选单位，需要等待采购人同意退款'
  },
  DELAY_RETURN: {
    value: 9,
    label: '已申请（保证金将在5日内有息退回）',
    type: 'warning',
    tipLabel: '退回中',
    tip: '已申请，5日内有息退款'
  },
  NOT_FULLY_PAID: {
    value: 10, // 项目异常，保证金可立即退款
    label: '待申请',
    type: 'warning',
    tipLabel: '未退回',
    tip: '项目流标,立即退款'
  },
  QUEUE_REFUND1: {
    value: 11,
    label: '退回中',
    type: 'warning',
    tipLabel: '退回中',
    tip: '排队退款,立即退款'
  },
  QUEUE_REFUND2: {
    value: 12,
    label: '退回中',
    type: 'warning',
    tipLabel: '退回中',
    tip: '排队退款，等待5日'
  }
})

// 保证金冻结状态
export const depositFreezeStatusDict = new Dict({
  FREEZE: { label: '已冻结', value: 1 },
  THAW: { label: '已解冻', value: 2 }
})

// 是否数据字典
export const whetherDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})

// 是否数据字典 （1， 2）
export const whetherNewDict = new Dict({
  YES: { label: '是', value: 2 },
  NO: { label: '否', value: 1 }
})

// 是否数据字典Boolean形式
export const whetherBooleanDict = new Dict({
  YES: { label: '是', value: true },
  NO: { label: '否', value: false }
})

// 审批流审核状态
export const workFlowAuditStatusDict = new Dict({
  INIT: { label: '待提交审批', value: 0, type: 'info' },
  TO_AUDIT: { label: '审批中', value: 1, type: 'primary' },
  PASS: { label: '审核通过', value: 2, type: 'success' },
  REJECT: { label: '审核不通过', value: 3, type: 'danger' },
  WITHDRAWER: { label: '已撤回', value: 4, type: 'warning' }
})

// 发布媒体
export const releaseMediaDict = new Dict({
  1: { label: '中国招标投标公共服务平台', value: '1' }
})

// 其他材料类型
export const otherMaterialTypeDict = new Dict({
  ATTACHMENT: { label: '附件', value: 1 },
  TEXT: { label: '文本', value: 2 }
})

// 其他材料要求
export const otherMaterialRequirementDict = new Dict({
  REQUIRED: { label: '必填', value: 1, formLabel: '是' },
  NOT_REQUIRED: { label: '选填', value: 2, formLabel: '否' }
})

// 保证金支付方式
export const guaranteePayMethodDict = new Dict({
  MONEY_TRANSFER: {
    label: '银行转账',
    value: 1,
    checkboxLabel: '银行转账',
    // 用于采购人保证金退款列表显示
    tableLabel: '银行转账'
  },
  // 大地、金发统一为线上保函，目前金发功能下线，暂时只支持大地保函
  ONLINE_LETTER: {
    label: '投标保函',
    value: 2,
    checkboxLabel: '允许在线申请投标保函',
    // 用于采购人保证金退款列表显示
    tableLabel: '投标保函'
  },
  OFFLINE_LETTER: {
    label: '线下投标保函',
    value: 3,
    checkboxLabel: '允许提交线下投标保函',
    // 用于采购人保证金退款列表显示
    tableLabel: '投标保函-线下上传'
  },
  SHOW_LETTER: {
    label: '投标保函',
    value: 4,
    // 只用于修改保证金缴纳方式标识用的
    tableLabel: '投标保函'
  }
})

// 保证金缴款方式
export const depositPayMethodDict = new Dict({
  PRE_SAVE: { label: '灵活宝-保证金预存', value: 5 },
  VIP: { label: '会员保证金担保', value: 4 },
  MONEY_TRANSFER: { label: '银行转账', value: 1 }
})

// 保证金支付方式是否支持
export const guaranteePayMethodSupportDict = new Dict({
  YES: { label: '支持', value: 1 },
  NO: { label: '不支持', value: 0 }
})

// 保函申请类型
export const guaranteeLetterTypeDict = new Dict({
  ONLINE: { label: '线上保函', value: 1 },
  OFFLINE: { label: '线下保函', value: 0 }
})

// 线上电子保函状态
export const guaranteeLetterOnlineStatusDict = new Dict({
  APPLYING: { label: '申请中', value: 1, type: 'primary' },
  OPENED: { label: '已开立', value: 2, type: 'success' },
  OPEN_FAIL: { label: '开立失败', value: 3, type: 'danger' },
  EXPIRED: { label: '已过期', value: 5, type: 'info' },
  AUDITING: { label: '审核中', value: 6, type: 'primary' }
})

// 线上保函退款状态
export const guaranteeLetterOnlineRefundStatusDict = new Dict({
  REFUNDING: { label: '退款中', value: 1, type: 'primary' },
  REFUNDED: { label: '已退款', value: 2, type: 'success' },
  FAIL: { label: '退款失败', value: 3, type: 'danger' }
})

// 线上保函理赔状态
export const guaranteeLetterOnlineClaimStatusDict = new Dict({
  CLAIMING: { label: '理赔中', value: 1, type: 'primary' },
  PAID: { label: '已赔付', value: 2, type: 'success' },
  FAIL: { label: '赔付失败', value: 3, type: 'danger' }
})

// 线下电子保函状态
export const guaranteeLetterOfflineStatusDict = new Dict({
  INIT: { label: '未开立', value: 0, type: 'danger' },
  AUDIT_PENDING: { label: '待审核', value: 1, type: 'warning' },
  AUDIT_SUCCESS: { label: '审核通过', value: 2, type: 'success' },
  AUDIT_FAIL: { label: '审核不通过', value: 3, type: 'danger' }
})

// 流标原因
export const flowMarkDict = new Dict({
  SUPPLIER: { label: '报名供应商不足三家', value: 1 },
  DOCUMENT: { label: '递交文件不足三家', value: 2 },
  BID: { label: '评标中有效不足三家', value: 3 },
  COMPLAINT: { label: '投诉质疑后重新招标', value: 4 },
  TERMINATION: { label: '项目终止(重大变更)', value: 5 },
  OTHER: { label: '其他原因', value: -1 }
})

// 异议状态
export const objectionStatusDict = new Dict({
  NOREPLY: { label: '未答复', value: 1, type: 'warning' },
  YESREPLY: { label: '已答复', value: 2, type: 'success' }
})

// 异议类型
export const objectionTypeDict = new Dict({
  1: { label: '招标文件异议', value: 1 },
  2: { label: '开评标异议', value: 2 },
  3: { label: '公示异议', value: 3 },
  4: { label: '中标结果异议', value: 4 }
})

// 异议-问题类型
export const objectionRecordTypeDict = new Dict({
  OBJECT: { label: '异议', value: 1 },
  REPLY: { label: '异议答复', value: 2 }
})

// 公告发布状态
export const noticeReleaseStatusDict = new Dict({
  UN_RELEASE: { label: '待发布', value: 0, type: 'warning' },
  PENDING_RELEASE: { label: '发布中', value: 1, type: 'primary' },
  RELEASED: { label: '发布成功', value: 2, type: 'success' },
  FAIL_RELEASE: { label: '发布失败', value: 3, type: 'danger' }
})

// 公告发布设置
export const noticeReleaseSetDict = new Dict({
  NOW: { label: '立即发布', value: 1 },
  TIME: { label: '定时发布', value: 2 }
})

// 流标状态
export const closeStatusDict = new Dict({
  UN_CLOSE: { label: '编辑中', value: 0, type: 'primary' },
  PENDING_CLOSE: { label: '流标中', value: 1, type: 'warning' },
  CLOSED: { label: '流标成功', value: 2, type: 'success' },
  FAIL_CLOSE: { label: '流标失败', value: 3, type: 'danger' }
})

// 谈判状态
export const negotiationProjectStatusDict = new Dict({
  PUBLISHED: {
    label: '已发布',
    value: 1,
    type: 'primary'
  },
  DOING: {
    label: '进行中',
    value: 2,
    type: 'primary'
  },
  CANDIDATE: {
    label: '已公示',
    value: 3,
    type: 'primary'
  },
  WINNER: {
    label: '已完结',
    value: 4,
    type: 'success'
  },
  CLOSED: {
    label: '已终止谈判',
    value: 5,
    type: 'info',
    permission: ['look', 'copy'],
    routerName: 'NegotiationV2Info'
  },
  RESTART: {
    label: '已重新谈判',
    value: 6,
    type: 'info',
    permission: ['look', 'copy'],
    routerName: 'NegotiationV2Info'
  }
})

// 报价币种
export const currencyTypeDict = new Dict({
  YUAN: { value: 1, label: '元', name: '人民币' },
  DOLLAR: { value: 2, label: '美元', name: '美元' }
})

// 线上保函退款申请原因
export const guaranteeLetterOnlineRefundReasonDict = new Dict({
  NOT_START: { label: '未开标', value: '01' },
  CHANGE: { label: '延迟开标', value: '02' },
  CLOSE: { label: '流标', value: '03' }
})

// 保证金缴纳状态查询筛选
export const isGfPaySearchDict = new Dict({
  YES: { label: '已缴纳', value: 1 },
  NO: { label: '未缴纳', value: 0 }
})

// 报名费支付状态查询筛选
export const isSignUpFeeSearchDict = new Dict({
  YES: { label: '已支付', value: 1 },
  NO: { label: '未支付', value: 0 }
})

// 报名时段查看供应商参与名单
export const isSignupShowListingDict = new Dict({
  YES: { label: '查看', value: 1 },
  NO: {
    label: '不查看',
    value: 0,
    bidTips: '报名时段不查看报名供应商名单，则系统默认报名不需要审核',
    inquiryTips:
      '报价时段不查看报名供应商名单，则系统默认密封报价且报名不需要审核',
    competeTips: '报名时段不查看报名供应商名单，则系统默认报名不需要审核',
    negotiationTips: '报名时段不查看报名供应商名单，则系统默认报名不需要审核',
    negotiationV2Tips:
      '报价时段不查看报名供应商名单，则系统默认密封报价且报名不需要审核'
  }
})

/**
 * 品目税率
 */
export const unitTaxRateDict = new Dict({
  0: { label: '13', value: '13' },
  1: { label: '9', value: '9' },
  2: { label: '6', value: '6' },
  3: { label: '3', value: '3' }
})

// 是否是五菱
export const whetherWulingDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})

// 二维码信息核验字典
export const messageVerificationDict = new Dict({
  BIDDING: {
    value: 1,
    label: '招标'
  },
  INQUIRY: {
    value: 2,
    label: '询比'
  },
  COMPETE: {
    value: 3,
    label: '竞价'
  },
  NEGOTIATION: {
    label: '谈判采购',
    value: 8
  },
  NEGOTIATION_V2: {
    label: '谈判采购',
    value: 9
  },
  INQUIRY_COMPARE: {
    label: '询比比价',
    value: 10
  }
})

// 报价方式
export const offerTypeDict = new Dict({
  TOTAL_PRICE: {
    label: '总价',
    value: 1,
    show: true,
    labelText: '中标价',
    unit: '元'
  },
  UNIT_PRICE: {
    label: '单价',
    value: 2,
    show: true,
    labelText: '中标单价',
    unit: '元'
  },
  RATE: { label: '费率', value: 3, show: true, labelText: '费率', unit: '%' },
  OFFER_PRICE: {
    label: '综合报价',
    value: 4,
    show: false,
    labelText: '综合报价',
    unit: ''
  }
})

// 保证金退款是否需要招标方同意
export const bondBidRefundTypeDict = new Dict({
  YES: { label: '仅审核候选单位退款', value: 1 },
  ALL: { label: '审核全部投标单位退款', value: 3 },
  NO: { label: '全部单位退款都不审核', value: 2 }
})

// （供应商）供应商候选状态
export const isCandidateStatusDict = new Dict({
  INIT: { value: 0, label: '未确定', tipLabel: '-' },
  WIN: { value: 2, label: '候选', tipLabel: '是' },
  LOSE: { value: 3, label: '未候选', tipLabel: '否' }
})

// 中标通知书发布方式
export const winnerInformTypeDict = new Dict({
  PLATFORM: { label: '自定义通知书', value: 0 },
  ONLINE: { label: '线上上传', value: 1 },
  OFFLINE: { label: '线下邮寄', value: 2 }
})